"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FIXED_OVERLAY_ZINDEX = exports.TOOLTIP_ZINDEX = exports.SNACKBAR_ZINDEX = exports.HINT_ZINDEX = exports.DROPDOWN_ZINDEX = exports.POPUP_ZINDEX = void 0;

/**
 * Попап
 */
var POPUP_ZINDEX = 5000;
/*
 * Дропдаун
 */

exports.POPUP_ZINDEX = POPUP_ZINDEX;
var DROPDOWN_ZINDEX = 100;
/**
 * Хинт
 */

exports.DROPDOWN_ZINDEX = DROPDOWN_ZINDEX;
var HINT_ZINDEX = 500;
/**
 * Снэкбар
 */

exports.HINT_ZINDEX = HINT_ZINDEX;
var SNACKBAR_ZINDEX = 10000;
/**
 * Тултип
 */

exports.SNACKBAR_ZINDEX = SNACKBAR_ZINDEX;
var TOOLTIP_ZINDEX = 2000;
/**
 * Фиксированный оверлей
 */

exports.TOOLTIP_ZINDEX = TOOLTIP_ZINDEX;
var FIXED_OVERLAY_ZINDEX = 1000;
exports.FIXED_OVERLAY_ZINDEX = FIXED_OVERLAY_ZINDEX;